"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAR_TYPE = exports.ACCOUNT_SUFFIX = exports.EditRecordAction = exports.CheckSubAccountStatus = exports.SubAccountEnabledStatus = exports.AlgorithmId2CoinType = exports.AlgorithmId = exports.AccountStatus = exports.RecordType = exports.CoinType2ChainType = exports.CoinType2EvmChainId = exports.EvmChainId2CoinType = exports.ChainType = exports.EvmChainId = exports.CoinType = exports.BitNetwork = void 0;
var BitNetwork;
(function (BitNetwork) {
    BitNetwork["mainnet"] = "mainnet";
    BitNetwork["testnet"] = "testnet";
})(BitNetwork = exports.BitNetwork || (exports.BitNetwork = {}));
var CoinType;
(function (CoinType) {
    CoinType["ETH"] = "60";
    CoinType["TRX"] = "195";
    CoinType["CKB"] = "309";
    CoinType["MATIC"] = "966";
    CoinType["BSC"] = "9006";
})(CoinType = exports.CoinType || (exports.CoinType = {}));
var EvmChainId;
(function (EvmChainId) {
    EvmChainId[EvmChainId["ETH"] = 1] = "ETH";
    EvmChainId[EvmChainId["ETH_GOERILI"] = 5] = "ETH_GOERILI";
    EvmChainId[EvmChainId["BSC"] = 56] = "BSC";
    EvmChainId[EvmChainId["MATIC"] = 137] = "MATIC";
})(EvmChainId = exports.EvmChainId || (exports.EvmChainId = {}));
var ChainType;
(function (ChainType) {
    ChainType[ChainType["ckb"] = 0] = "ckb";
    ChainType[ChainType["eth"] = 1] = "eth";
    ChainType[ChainType["btc"] = 2] = "btc";
    ChainType[ChainType["tron"] = 3] = "tron";
    ChainType[ChainType["fiat"] = 4] = "fiat";
    ChainType[ChainType["bsc"] = 56] = "bsc";
    ChainType[ChainType["polygon"] = 137] = "polygon";
})(ChainType = exports.ChainType || (exports.ChainType = {}));
exports.EvmChainId2CoinType = {
    [EvmChainId.ETH]: CoinType.ETH,
    [EvmChainId.ETH_GOERILI]: CoinType.ETH,
    [EvmChainId.BSC]: CoinType.BSC,
    [EvmChainId.MATIC]: CoinType.MATIC,
};
exports.CoinType2EvmChainId = {
    [CoinType.ETH]: EvmChainId.ETH,
    [CoinType.MATIC]: EvmChainId.MATIC,
    [CoinType.BSC]: EvmChainId.BSC,
};
exports.CoinType2ChainType = {
    [CoinType.ETH]: ChainType.eth,
    [CoinType.TRX]: ChainType.tron,
    [CoinType.CKB]: ChainType.ckb,
    [CoinType.MATIC]: ChainType.polygon,
    [CoinType.BSC]: ChainType.bsc,
};
var RecordType;
(function (RecordType) {
    RecordType["address"] = "address";
    RecordType["profile"] = "profile";
    RecordType["dweb"] = "dweb";
    RecordType["custom"] = "custom";
})(RecordType = exports.RecordType || (exports.RecordType = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus[AccountStatus["noneExist"] = 0] = "noneExist";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
var AlgorithmId;
(function (AlgorithmId) {
    AlgorithmId[AlgorithmId["ethPersonalSign"] = 3] = "ethPersonalSign";
    AlgorithmId[AlgorithmId["tronSign"] = 4] = "tronSign";
    AlgorithmId[AlgorithmId["eip712"] = 5] = "eip712";
    AlgorithmId[AlgorithmId["ed2519"] = 6] = "ed2519";
})(AlgorithmId = exports.AlgorithmId || (exports.AlgorithmId = {}));
exports.AlgorithmId2CoinType = {
    [AlgorithmId.ethPersonalSign]: CoinType.ETH,
    [AlgorithmId.eip712]: CoinType.ETH,
    [AlgorithmId.tronSign]: CoinType.TRX,
};
var SubAccountEnabledStatus;
(function (SubAccountEnabledStatus) {
    SubAccountEnabledStatus[SubAccountEnabledStatus["unknown"] = -1] = "unknown";
    SubAccountEnabledStatus[SubAccountEnabledStatus["off"] = 0] = "off";
    SubAccountEnabledStatus[SubAccountEnabledStatus["on"] = 1] = "on";
})(SubAccountEnabledStatus = exports.SubAccountEnabledStatus || (exports.SubAccountEnabledStatus = {}));
var CheckSubAccountStatus;
(function (CheckSubAccountStatus) {
    CheckSubAccountStatus[CheckSubAccountStatus["ok"] = 0] = "ok";
    CheckSubAccountStatus[CheckSubAccountStatus["fail"] = 1] = "fail";
    CheckSubAccountStatus[CheckSubAccountStatus["registered"] = 2] = "registered";
    CheckSubAccountStatus[CheckSubAccountStatus["registering"] = 3] = "registering";
})(CheckSubAccountStatus = exports.CheckSubAccountStatus || (exports.CheckSubAccountStatus = {}));
var EditRecordAction;
(function (EditRecordAction) {
    EditRecordAction["delete"] = "delete";
    EditRecordAction["change"] = "change";
    EditRecordAction["add"] = "add";
})(EditRecordAction = exports.EditRecordAction || (exports.EditRecordAction = {}));
exports.ACCOUNT_SUFFIX = '.bit';
var CHAR_TYPE;
(function (CHAR_TYPE) {
    CHAR_TYPE[CHAR_TYPE["emoji"] = 0] = "emoji";
    CHAR_TYPE[CHAR_TYPE["number"] = 1] = "number";
    CHAR_TYPE[CHAR_TYPE["english"] = 2] = "english";
    CHAR_TYPE[CHAR_TYPE["simplifiedChinese"] = 3] = "simplifiedChinese";
    CHAR_TYPE[CHAR_TYPE["traditionalChinese"] = 4] = "traditionalChinese";
    CHAR_TYPE[CHAR_TYPE["japanese"] = 5] = "japanese";
    CHAR_TYPE[CHAR_TYPE["korean"] = 6] = "korean";
    CHAR_TYPE[CHAR_TYPE["russian"] = 7] = "russian";
    CHAR_TYPE[CHAR_TYPE["turkish"] = 8] = "turkish";
    CHAR_TYPE[CHAR_TYPE["thai"] = 9] = "thai";
    CHAR_TYPE[CHAR_TYPE["vietnamese"] = 10] = "vietnamese";
    CHAR_TYPE[CHAR_TYPE["unknown"] = 99] = "unknown";
})(CHAR_TYPE = exports.CHAR_TYPE || (exports.CHAR_TYPE = {}));
//# sourceMappingURL=const.js.map